import { useState } from "react";
import { NXEyes } from "../../icons";
import useApi from "../../api";
import CustomerDetails from "./CustomerDetails";
import CustomerEdit from "./CustomerEdit";
import GenericSelectableTable from "../selectableTable";

function CustomerTable({ customerData }: { customerData: any }) {
  const [customer, setCustomer] = useState<any>(null);
  const [edit, setEdit] = useState<any>(null);
  const api = useApi();

  // Define columns with render functions for custom content
  const columns = [
    { header: "Customer Name", key: "full_name", render: (item: any) => (
      <div className="flex items-center gap-5">
        <div className="w-[50px] aspect-square rounded-full bg-base-400">
          <img src={item?.avatar} alt="" className="w-[50px] h-[50px] aspect-square rounded-full object-cover" />
        </div>
        <span className="text-nowrap">{item?.full_name}</span>
      </div>
    )},
    { header: "Username", key: "username" },
    { header: "Email", key: "email" },
    { header: "Location", key: "default_shipping_address", render: (item: any) => (
      item.default_shipping_address ? 
      `${item.default_shipping_address.street_address}, ${item.default_shipping_address.postal_code}, ${item.default_shipping_address.city}, ${item.default_shipping_address.state}, ${item.default_shipping_address.country}` :
      "-"
    )},
    { header: "Order", key: "total_order_count" },
    { header: "Spent", key: "total_spent" },
    { header: "Actions", key: "actions", render: (item: any) => (
      <div className="flex gap-2">
        <button className="text-primary-500 hover:underline"
          onClick={(e) => {
            e.preventDefault();
            setCustomer(item.id);
          }}
        >
          <NXEyes className="hover:stroke-primary-400 cursor-pointer transition-all duration-150 ease-linear" />
        </button>
        <button className="text-primary-500 hover:underline" onClick={() => setEdit(item.id)}>
          Edit
        </button>
      </div>
    )}
  ];

  return (
    <>
      <div className="relative overflow-x-auto">
        <GenericSelectableTable columns={columns} data={customerData?.results || []} />

        {/* Customer details modal */}
        {customer && (
          <CustomerDetails id={customer} isOpen={customer ? true : false} onClose={() => setCustomer(null)} />
        )}
        {edit && (
          <CustomerEdit id={edit} isOpen={edit ? true : false} onClose={() => setEdit(null)} />
        )}
      </div>
    </>
  );
}

export default CustomerTable;
